import { atlas } from 'graphql/tags'

import { MANUAL_TRANSACTION_FRAGMENT } from './ManualTransactions.queries'

export const CREATE_MANUAL_TRANSACTION_MUTATION = atlas`#graphql
  mutation CreateManualTransaction($input: CreateManualPaymentRecordInput!) {
    createManualPaymentRecord(input: $input) {
      ...ManualTransaction
    }
  }
  ${MANUAL_TRANSACTION_FRAGMENT}
`

export const UPDATE_MANUAL_TRANSACTION_MUTATION = atlas`#graphql
  mutation UpdateManualTransaction($input: UpdateManualPaymentRecordInput!) {
    updateManualPaymentRecord(input: $input) {
      ...ManualTransaction
    }
  }
  ${MANUAL_TRANSACTION_FRAGMENT}
`

export const DELETE_MANUAL_TRANSACTION_MUTATION = atlas`#graphql
  mutation DeleteManualTransaction($input: DeleteManualPaymentRecordInput!) {
    deleteManualPaymentRecord(input: $input) {
      ok
    }
  }
`
